import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  capitalizeFirstLetter,
  formatDateTime,
  getUserStatus,
  getGender,
  isUserActive,
  isAdminUser,
  hasPermission,
} from "utils/helper";
import { IoMdClose } from "react-icons/io";
import { AiOutlineEdit } from "react-icons/ai";
import {
  Typography,
  BeadCrumb,
  Switch,
  Modal,
  Button,
  OnboardingDetails,
} from "components";
import { useSelector } from "react-redux";
import AgentTerminals from "./AgentTerminals";
import AggregatorAgents from "./AggregatorAgents";
import EditUserModal from "./EditUserModal";
import userAvatar from "assets/images/user-avatar.png";
import { permissions } from "utils/permissions";

import "../../style.scss";

const UserProfile = () => {
  const {
    state: { userInfo, userType: typeOfUser },
  } = useLocation();

  const {
    agentDetails,
    dateOfBirth,
    email,
    firstName,
    gender,
    lastName,
    username,
    phoneNumber,
    userType,
    roles,
  } = userInfo;

  const { user } = useSelector((state) => state.user);

  const userAuthorities = user?.authorities;

  let status = userInfo.status || userInfo.agentDetails.status;

  let isOn = status === "ENABLED";

  const [checked, setChecked] = useState(isOn);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [KYCView, setKYCView] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleStatusChange = (e) => {
    setShowModal(true);
    setChecked(e.target.checked);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setChecked(isOn);
  };

  const handleActivateDeactivate = () => {
    setLoading();
    //after succcess response, redirect to users page
    //set Alert
  };

  const getUserDetails = () => {
    let userDetails = [
      { label: "First Name", value: capitalizeFirstLetter(firstName) },
      { label: "Last Name", value: capitalizeFirstLetter(lastName) },
      { label: "User Name", value: capitalizeFirstLetter(username) },
      { label: "Gender", value: getGender(gender)?.label },
      { label: "Phone Number", value: phoneNumber },
      { label: "Email", value: email },
    ];

    if (isAdminUser(user)) {
      if (userType !== "ADMIN_USER") {
        //Admin users on the system do not have DOB
        userDetails.push({
          label: "Date Of Birth",
          value: formatDateTime(dateOfBirth),
        });
      }
      userDetails.push({ label: "Role", value: roles[0] });
    }

    return userDetails;
  };

  return (
    <div className="dashboard-page-container">
      <div className="beadcrumb-margin">
        <BeadCrumb titles={["Users", "User Profile"]} />
      </div>
      <div className="mx-auto profile-container">
        {/* Condition of if user is active/disabled and check if admin or user permission. Remove d-none, hid until when to implement ===================================REMEMBER */}
        <div className="d-flex justify-content-between user-status d-none">
          <Typography variant="body4">
            You can Disable/Enable this user's status here
          </Typography>

          <Switch checked={checked} handleChange={handleStatusChange} />
        </div>

        <div className="user-profile-header d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <img src={userAvatar} alt="" height="45px" />
            <div className="mx-3">
              <Typography variant="body4" state="primary">
                {capitalizeFirstLetter(firstName)}{" "}
                {capitalizeFirstLetter(lastName)}
              </Typography>
              <Typography variant="body3" state="primary">
                {agentDetails?.agentCode}
              </Typography>
            </div>
          </div>
          <div>
            <Typography variant="body4" component="span" state="primary">
              Status
            </Typography>
            :{" "}
            <Typography
              variant="body3"
              component="span"
              style={{ color: getUserStatus(status)?.color }}
            >
              {getUserStatus(status)?.label}
            </Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 profile-title-container">
            <Typography
              state={!KYCView ? "primary" : "grey"}
              variant="body0"
              className={`profile-title ${
                !KYCView ? "profile-title--active" : ""
              } cursor-pointer`}
              onClick={() => setKYCView(false)}
            >
              Profile Information
            </Typography>{" "}
            {/* Ensure the person performing the action has appropriate paermission
            Ensure the user being checked is not an admin user */}
            {hasPermission(permissions.canUpdateAgent, userAuthorities) &&
              userType !== "ADMIN_USER" && (
                <span onClick={() => setIsEditModalOpen(true)}>
                  Edit User <AiOutlineEdit />
                </span>
              )}
          </div>
          {/* Ensure the person being checked is not an admin user, they do not have KYC
          Ensure this person is also active, that is; has been verified 
          Ensure the person performing this act of checking a user kyc is an admin user and not an aggregator
      */}
          {userType !== "ADMIN_USER" &&
            isUserActive(status) &&
            isAdminUser(user) && (
              <div className="col-md-6">
                <Typography
                  state={KYCView ? "primary" : "grey"}
                  variant="body0"
                  className={`profile-title ${
                    KYCView ? "profile-title--active" : ""
                  } cursor-pointer`}
                  onClick={() => setKYCView(true)}
                >
                  KYC Details
                </Typography>
              </div>
            )}
        </div>

        {KYCView ? (
          <div style={{ marginTop: "3rem" }}>
            <OnboardingDetails
              agentId={agentDetails?.agentId}
              agentCode={agentDetails?.agentCode}
            />
          </div>
        ) : (
          <>
            <div className="row user-detail-container">
              {getUserDetails().map(({ label, value }, key) => (
                <div className="col-md-6 mt-3" key={key}>
                  <Typography>
                    {label}: &nbsp; &nbsp; {value}
                  </Typography>
                </div>
              ))}
            </div>
            {typeOfUser === "aggregator" && (
              <AggregatorAgents aggregatorId={agentDetails?.agentId} />
            )}
            {typeOfUser !== "admin" && (
              <div style={{ marginTop: "5rem" }}>
                <AgentTerminals agentId={agentDetails?.agentId} />
              </div>
            )}
          </>
        )}
      </div>
      <Modal showModal={showModal} onClose={handleModalClose}>
        <div className="my-4">
          <div className="d-flex justify-content-end">
            <IoMdClose className="cursor-pointer" onClick={handleModalClose} />
          </div>
          <div className="text-center mt-2 mx-auto" style={{ width: "90%" }}>
            <div className="my-4">
              <Typography variant="body1" state="primary" className="mt-3 mb-4">
                Are you sure you want to {isOn ? "deactivate" : "activate"} this
                User?
              </Typography>
              <div className="d-flex justify-content-center">
                <Button
                  size="xs"
                  variant="secondary"
                  label="Cancel"
                  onClick={handleModalClose}
                />{" "}
                &nbsp; &nbsp;{" "}
                <Button
                  label={isOn ? "Deactivate" : "Activate"}
                  size="xs"
                  variant={isOn ? "danger" : "primary"}
                  onClick={handleActivateDeactivate}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <EditUserModal
        userInfo={{
          email: userInfo.email,
          phoneNumber: userInfo.phoneNumber,
          id: userInfo.id,
        }}
        isModalVisible={isEditModalOpen}
        setIsModalVisible={setIsEditModalOpen}
      />
    </div>
  );
};

export default UserProfile;
